import { Autocomplete, TextField } from "@mui/material";


export interface AutocompleteProps {
  label?: string;
  options: any[];
  fullWidth?: boolean;
  defaultbg?: boolean;
  error?: boolean;
  helperText?: string;
  required?: boolean;
  name?: string;
  placeholder?: string;
  [key: string]: any;
}

export default function AutocompleteInput({
  label,
  options,
  fullWidth,
  error,
  required,
  name,
  helperText,
  placeholder,
  defaultbg,
  ...props
}: AutocompleteProps) {
  return (
    <Autocomplete
      sx={{
        fontSize: "12px", // Style global pour le composant
        width: "100%",
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: "#dcdde0", // Couleur de la bordure par défaut
          },
          "&:hover fieldset": {
            borderColor: "#dcdde0", // Couleur de la bordure au survol
          },
          "&.Mui-focused fieldset": {
            borderColor: "#dcdde0", // Couleur de la bordure quand le champ est focus
          },
        },
        "& .MuiAutocomplete-root": {
          fontSize: "12px",
        },
        "& .MuiInputBase-root": {
          fontSize: "12px",
          height: "2.5rem",
        },
        "& .MuiInputBase-input": {
          fontSize: "12px", // Texte dans le champ de saisie
        },
        "& .MuiFormLabel-root": {
          fontSize: "12px", // Label du champ
        },
        "& .MuiAutocomplete-option": {
          fontSize: "12px", // Options du menu déroulant
        },
        "& .MuiAutocomplete-listbox": {
          fontSize: "12px", // Applique la taille de police aux options de la liste
        },
      }}
      {...props}
      options={options}
      data-testid="mui-autocomplete"
      renderInput={(params: any) => (
        <>
          <TextField
            style={{
              backgroundColor: props?.disabled
                ? "#ebf0f3"
                : defaultbg
                ? "#FFF"
                : "#ebf0f3"
            }}
            name={name}
            helperText={helperText}
            error={error}
            required={required}
            fullWidth={fullWidth}
            {...params}
            label={label}
            placeholder={placeholder}
          />
        </>
      )}
    />
  );
}
